// extracted by mini-css-extract-plugin
export var textarea = "SectionTitleBody-module--textarea--f7005";
export var titlebodyinner = "SectionTitleBody-module--titlebodyinner--2df28";
export var titlebodysectionbreak = "SectionTitleBody-module--titlebodysectionbreak--0aa90";